/* eslint-disable new-cap */
import { useState, useEffect, useContext } from 'react';
import {
  Typography,
  Row,
  Col,
  Modal,
  Space,
  Image,
  Table,
  Checkbox,
  Divider,
} from 'taxaroo-ui';
import { jsPDF } from 'jspdf';
import { JobContext } from '~src/components/providers/job-provider';
import { PaymentsEntity } from '~src/graphql';
import { useGetBusinessInformationQuery, useGetCustomLayoutsQuery } from '~src/graphql/queries/settings';
import Firms from '~src/components/helpers/firms';
import Users from '~src/components/helpers/users';
import { useGetTaxYearInterviewIncludeInterviewsLazyQuery } from '~src/graphql/queries/taxYearInterview';
import { useGetFirmLogoLazyQuery } from '~src/graphql/queries/payments';

const { Paragraph, Text, Title } = Typography;

interface ViewInvoiceModalProps {
    paymentData: PaymentsEntity
    isModalVisible: boolean
    setIsModalVisible: (b: boolean) => void
}

const faultTolerantImage = 'data:image/png;base64,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';

const columns = [
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Price Each',
    dataIndex: 'priceEach',
    key: 'priceEach',
    render: (val: any, row: any) => `$${val}`,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: 'Item Total',
    dataIndex: 'totalDallarAmount',
    key: 'totalDallarAmount',
    render: (val: any, row: any) => `$${(row.quantity * row.priceEach).toFixed(2)}`,
  },
];

function ViewInvoiceModal({
  paymentData,
  isModalVisible,
  setIsModalVisible,
}: ViewInvoiceModalProps) {
  const [getFirmLogo] = useGetFirmLogoLazyQuery();
  const [getTaxYearInterviewIncludeInterviews] = useGetTaxYearInterviewIncludeInterviewsLazyQuery();

  const {
    clientFirstName,
    clientLastName,
  } = useContext(JobContext);

  const [companyInformationData, setCompanyInformationData] = useState<any[]>([]);

  const { data: customLayoutData } = useGetCustomLayoutsQuery();
  const customLayout = customLayoutData?.CustomLayout;
  const { data: firmAccountInfoData } = useGetBusinessInformationQuery();
  const firmAccount = firmAccountInfoData?.BusinessInformation;

  const generateCompanyInformationData = () => {
    const firmAddress = firmAccount?.Address?.[0]?.lineOne
      ? `${firmAccount?.Address?.[0]?.lineOne}, 
        ${firmAccount?.Address?.[0]?.lineTwo}, 
        ${firmAccount?.Address?.[0]?.city}, 
        ${firmAccount?.Address?.[0]?.state}, 
        ${firmAccount?.Address?.[0]?.zip}`
      : null;

    const data = [];
    if (firmAccount?.FirmAccount?.name) {
      data.push({ title: 'Firm Name', value: firmAccount?.FirmAccount?.name });
    }
    if (firmAddress) {
      data.push({ title: 'Firm Address', value: firmAddress });
    }
    if (firmAccount?.Phones?.[0]?.value) {
      data.push({ title: 'Firm Phone', value: firmAccount?.Phones?.[0]?.value });
    }
    setCompanyInformationData(data);
  };

  useEffect(() => {
    generateCompanyInformationData();
  }, [firmAccountInfoData]);

  const getInterviewAnswer = (section, questionDescription, answers) => {
    const question = section.Questions?.find((q) => q.Translations?.some((t) => t.description === questionDescription));
    const answer = question ? answers.find((a) => a.questionId === question.id) : null;
    return answer?.description;
  };

  const extractClientAddressFromInterview = (interviewData) => {
    const content = interviewData.GetTaxYearInterviewIncludeInterviews;
    const interview = content?.Interviews;
    const answers = content?.Answers;

    const clientSection = interview?.Sections?.find((s) => s.Translations?.some((t) => t.description === 'Basic Personal Information'));
    if (clientSection) {
      const lineOne = getInterviewAnswer(clientSection, 'Address Line 1', answers);
      const lineTwo = getInterviewAnswer(clientSection, 'Address Line 2', answers);
      const city = getInterviewAnswer(clientSection, 'City', answers);
      const state = getInterviewAnswer(clientSection, 'State/Province/Region', answers);
      const zip = getInterviewAnswer(clientSection, 'ZIP/Postal Code', answers);
      return {
        lineOne, lineTwo, city, state, zip,
      };
    }

    const businessSection = interview?.Sections?.find((s) => s.Translations?.some((t) => t.description === 'Business Information'));
    if (businessSection) {
      const lineOne = getInterviewAnswer(businessSection, 'Address Line 1', answers);
      const lineTwo = getInterviewAnswer(businessSection, 'Address Line 2', answers);
      const city = getInterviewAnswer(businessSection, 'City', answers);
      const state = getInterviewAnswer(businessSection, 'State/Province/Region', answers);
      const zip = getInterviewAnswer(businessSection, 'ZIP/Postal Code', answers);
      return {
        lineOne, lineTwo, city, state, zip,
      };
    }

    return null;
  };

  const combineLines = (line1, line2) => (
    `${line1 ?? ''}${line1 && line2 ? ', ' : ''}${line2 ?? ''}`
  );

  const combineAddress = (city, state, zip) => (
    `${city?.trim() ?? ''}${city && state ? ', ' : ''}${state?.trim() ?? ''}${(city || state) && zip ? ' ' : ''}${zip?.trim() ?? ''}`
  );

  const download = async (invoice) => {
    const PDF_LOGO_WIDTH = 60;
    const PDF_LOGO_HEIGHT = 30;

    const firm = invoice?.FirmAccount;

    const { data: logoData } = await getFirmLogo({
      variables: { id: firm?.id },
    });

    const { data: interviewData } = await getTaxYearInterviewIncludeInterviews({
      variables: { id: invoice?.taxYearInterviewId },
    });

    const firmName = Firms.getFirmName(firm);
    const firmUserInfo = firm?.Users?.UserInformation;
    const firmAddress = firm?.BusinessInformation?.Address?.[0] ?? firmUserInfo?.Address?.[0];
    const firmAddressLine = combineLines(firmAddress?.lineOne, firmAddress?.lineTwo);
    const firmAddressTail = combineAddress(firmAddress?.city, firmAddress?.state, firmAddress?.zip);
    const firmPhone = firm?.BusinessInformation?.Phones?.[0]?.value ?? firm?.Users?.UserInformation?.Phones?.[0]?.value ?? '';

    const client = invoice?.Entity?.Users;
    const clientInformation = client?.UserInformation || {};
    const clientAddress = clientInformation?.Address?.[0] || extractClientAddressFromInterview(interviewData);
    const clientAddressLine = combineLines(clientAddress?.lineOne, clientAddress?.lineTwo);
    const clientAddressTail = combineAddress(clientAddress?.city, clientAddress?.state, clientAddress?.zip);
    const clientPhone = clientInformation?.Phones?.[0].value ?? '';

    const doc = new jsPDF();

    const firmLogo = logoData?.GetFirmLogo;
    if (firmLogo) {
      const logoWidth = firmLogo?.width;
      const logoHeight = firmLogo?.height;
      const ratio = Math.min(PDF_LOGO_WIDTH / logoWidth, PDF_LOGO_HEIGHT / logoHeight);
      doc.addImage(firmLogo?.base64, 10, 15, logoWidth * ratio, logoHeight * ratio);
    }

    const date = new Date(invoice?.requestAt);
    const month = date.getMonth() + 1 < 10
      ? `0${date.getMonth() + 1}`
      : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const prettyDate = `${month}-${day}-${date.getFullYear()}`;

    const dy = 10; // line height
    let y = 10;
    doc.text(`${firmName || ''}`, 200, y += dy, { align: 'right' });
    doc.text(firmAddressLine, 200, y += dy, { align: 'right' });
    doc.text(firmAddressTail, 200, y += dy, { align: 'right' });
    doc.text(firmPhone, 200, y += dy, { align: 'right' });

    y += dy;
    doc.line(10, y, 205, y);

    doc.text(`${Users.getUserName(client)}`, 10, y += dy);
    doc.text(clientAddressLine, 10, y += dy);
    doc.text(clientAddressTail, 10, y += dy);
    doc.text(clientPhone, 10, y += dy);

    y += dy * 0.5;
    doc.line(10, y, 205, y);

    if (prettyDate && prettyDate !== 'NaN-NaN-NaN') {
      doc.text(`Date: ${prettyDate}`, 10, y += dy);
    }

    y += dy * 3.5;
    doc.text('Description', 10, y);
    doc.text('Price Each', 90, y);
    doc.text('Quantity', 140, y);
    doc.text('Item total', 180, y);

    y += dy * 0.2;
    doc.line(10, y, 70, y);
    doc.line(85, y, 118, y);
    doc.line(130, y, 161, y);
    doc.line(170, y, 203, y);

    y += dy * 0.8;
    invoice.Invoices.forEach((el) => {
      doc.text(el.description, 10, y);
      doc.text(`$${el.priceEach}`, 118, y, { align: 'right' });
      doc.text(String(el.quantity), 161, y, { align: 'right' });
      doc.text(`$${el.priceEach * el.quantity}`, 203, y, {
        align: 'right',
      });
      y += dy;
    });

    doc.line(10, y, 205, y);

    y += dy * 0.8;
    doc.text('Total', 150, y);
    doc.text(`$${invoice?.totalDollarAmount?.toFixed(2)}`, 203, y, { align: 'right' });
    doc.autoPrint();
    // This is a key for printing
    doc.output('dataurlnewwindow');
  }; // end downlaod

  const exportToPDFButtonOnClick = () => {
    download(paymentData);
    setIsModalVisible(false);
  };

  const cancelButtonOnClick = () => {
    setIsModalVisible(false);
  };

  const getFirstCharacterCapitalized = (text: string) => {
    if (!text) {
      return '';
    }

    return text[0].toUpperCase();
  };

  const modalTitle = (userName: string) => (
    <>
      <Row>
        <Col span={20}>
          <Title level={4}>View Invoice</Title>
        </Col>
        <Col span={3}>
          <Image
            style={{ position: 'absolute', top: '-1em' }}
            width={95}
            // src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
            src={customLayout?.logo}
            fallback={faultTolerantImage}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Space direction="horizontal">
            <Text type="secondary">{userName}</Text>
          </Space>
        </Col>
      </Row>
    </>
  );

  return (
    <Modal
      bodyStyle={{ maxHeight: 450, overflowY: 'scroll' }}
      title={modalTitle(`${clientFirstName} ${clientLastName}`)}
      okText="Export To PDF"
      cancelText="Close"
      centered
      visible={isModalVisible}
      onOk={exportToPDFButtonOnClick}
      onCancel={cancelButtonOnClick}
      width={1000}
    >
      <Row>
        <Col span={24}>
          {Boolean(companyInformationData.length) && (
          <Row>
            <Paragraph strong style={{ textTransform: 'capitalize' }}>
              {companyInformationData.map((el) => el.value).join(', ')}
            </Paragraph>
          </Row>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={paymentData?.Invoices}
          />
        </Col>
      </Row>
      {paymentData?.paidOffline && (
        <Row>
          <Col span={24}>
            <Checkbox disabled checked onChange={() => undefined}>
              <strong>
                This invoice was already paid offline (do not request payment from client)
              </strong>
            </Checkbox>
          </Col>
        </Row>
      )}
      <Divider />
      <Row>
        <Col span={20} />
        <Col span={2}>
          <Text>Total:</Text>
        </Col>
        <Col span={2}>
          <Text>
            $
            {paymentData?.totalDollarAmount?.toFixed(2)}
          </Text>
        </Col>
      </Row>
    </Modal>
  );
}

export default ViewInvoiceModal;
